import { FC, ReactNode } from "react";
import { TeamContext } from "../../types/common";
import { StatsType } from "../../types/stats";
import { getUrlByContext } from "../../utils";
import { CalendarOutlined, SkinOutlined, TableOutlined } from "@ant-design/icons";
import { Link } from "../../components";

interface SelectorItemProps {
    url: string;
    icon: ReactNode;
    label?: string;
    selected?: boolean;
}
const SelectorItem: FC<SelectorItemProps> = ({
    url,
    icon,
    label,
    selected,
}) => {
    let classNames = "px-4 py-1 rounded-full text items-center text-center flex flex-col sm:flex-row gap-2 transition-all hover:no-underline";
    if (!selected) {
        classNames += " text-white bg-slate-950 hover:bg-slate-800";
    } else {
        classNames += " font-bold text-slate-950 bg-white hover:bg-slate-100";
    }
    return (
        <>
            <Link to={url} className={classNames}>
                <span className="text-2xl">
                    {icon}
                </span>
                <span className="hidden sm:inline">
                    {label}
                </span>
            </Link>
        </>
    )
}

interface StatsSelectorProps {
    teamContext?: TeamContext;
    selected?: StatsType;
    items?: StatsType[];
}

export const StatsSelector: FC<StatsSelectorProps> = ({
    teamContext,
    selected,
    items,
}) => {
    const searchParams = new URLSearchParams(globalThis.location.search);

    return (
        <div className="transition-all opacity-90 hover:opacity-100 bg-slate-950 w-fit rounded-full flex flex-row items-center justify-center gap-1 p-1 border-2 border-white border-solid shadow hover:shadow-lg hover:border-slate-100 mx-auto">
            {(!items || items.includes(StatsType.CALENDAR)) && <SelectorItem
                icon={<CalendarOutlined />}
                url={getUrlByContext(`/games/?${searchParams.toString()}`, teamContext)}
                label="Календарь"
                selected={selected === StatsType.CALENDAR}
            />}
            {(!items || items.includes(StatsType.TOURNAMENT_TABLE)) && <SelectorItem
                icon={<TableOutlined />}
                url={getUrlByContext(`/games/tables/?${searchParams.toString()}`, teamContext)}
                label="Таблица"
                selected={selected === StatsType.TOURNAMENT_TABLE}
            />}
            {(!items || items.includes(StatsType.PLAYER)) && <SelectorItem
                icon={<SkinOutlined />}
                url={getUrlByContext(`/games/stat/?${searchParams.toString()}`, teamContext)}
                label="Статистика игроков"
                selected={selected === StatsType.PLAYER}
            />}
        </div>
    )
}